import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex-none" }
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "de" }, "DE", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "EN", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "fr" }, "FR", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "tr" }, "TR", -1)
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ArrowIcon, {
      type: "down",
      width: 20,
      class: "absolute top-2.5 left-8 pointer-events-none"
    }),
    _createElementVNode("select", {
      id: "locale-select",
      class: "border text-gray-600 bg-grey-light h-10 w-14 pl-1 pr-1 bg-white appearance-none cursor-pointer",
      value: _ctx.$i18n.locale,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeLanguage && _ctx.changeLanguage(...args))),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected')))
    }, _hoisted_7, 40, _hoisted_2)
  ]))
}